import { useState } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';
import PlusSolidIcon from '@simplywallst/ui-core/icons/PlusSolid';
import { Button } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';
import {
  ManualPortfolioProvider,
  useManualPortfolioContext,
  useManualPortfolioTracking,
} from '../../../../components/PortfolioManual';
import useUser from '@/hooks/useUser';

const GuestRegistrationModal = loadable(
  () => import('@/components/GuestRegistrationModal')
);

export const NewManualPortfolio = () => {
  const [openModal, setOpenModal] = useState(false);
  const { data } = useUser();
  const { trackEvent } = useTracking();

  const { trackManualPortfolioEvent } = useManualPortfolioTracking();
  const { createPortfolio } = useManualPortfolioContext();

  return (
    <ManualPortfolioProvider>
      <div
        className="grid gap-x2 sm:gap-x3"
        data-cy-id="portfolio-manual-creation"
      >
        <div className="grid gap-x1_25">
          <Heading as="h2">Track your holdings manually</Heading>
          <div className="max-w-[45ch] text-pretty text-xs text-softer">
            Add your holdings information such as average prices and number of
            shares. Support for transactions will be available soon.
          </div>
        </div>
        <Button
          styleType="louderLarge"
          alignIcon="left"
          onClick={() => {
            if (!data.loggedIn) {
              setOpenModal(true);
              return;
            }

            trackManualPortfolioEvent({
              modifier: 'create-portfolio',
              action: 'click',
            });
            createPortfolio();
          }}
          className="w-fit"
        >
          Add my portfolio
          <PlusSolidIcon />
        </Button>
      </div>
      {openModal && (
        <GuestRegistrationModal
          canClose
          onClose={() => {
            trackEvent({
              action: 'close',
              modifier: 'log_in_sign_up',
            });
            setOpenModal(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioAddPortfolioWidgetManual',
              modifier: 'registration',
              action: 'success',
            });
            setOpenModal(false);
          }}
          onLoginSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioAddPortfolioWidgetManual',
              modifier: 'login',
              action: 'success',
            });
            setOpenModal(false);
          }}
        />
      )}
    </ManualPortfolioProvider>
  );
};
